import { RootState } from 'src/store';
import { createSelector } from '@reduxjs/toolkit';

export const safeStateSelector = (state: RootState) => state.login;

export const loginLoadingSelector = createSelector(
  safeStateSelector,
  (loginState) => loginState.loading,
);
export const errorLoadingSelector = createSelector(
  safeStateSelector,
  (loginState) => loginState.error,
);
export const loginStepSelector = createSelector(
  safeStateSelector,
  (loginState) => loginState.currentStep,
);

export const codeVerifySelector = createSelector(
  safeStateSelector,
  (loginState) => loginState.codeVerified,
);

export const codeIdSelector = createSelector(safeStateSelector, (loginState) => loginState.codeId);

export const loginEmailSelector = createSelector(
  safeStateSelector,
  (loginState) => loginState.email,
);
